import { render, staticRenderFns } from "./groupLiaisonDia.vue?vue&type=template&id=6e2790c9&scoped=true&"
import script from "./groupLiaisonDia.vue?vue&type=script&lang=js&"
export * from "./groupLiaisonDia.vue?vue&type=script&lang=js&"
import style0 from "./groupLiaisonDia.vue?vue&type=style&index=0&id=6e2790c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2790c9",
  null
  
)

export default component.exports